import Suggestions from './Suggestions'

export default Suggestions



// WEBPACK FOOTER //
// ./src/components/SearchFilterInput/components/Suggestions/index.js